// const BASE_URL = "http://localhost:3000";

// const BASE_URL = "https://apicivilmantra.aimantra.info";
let BASE_URL = "https://hrms.aimantra.info";
// let BASE_URL = "https://5rn0m63d-8000.inc1.devtunnels.ms";

let BASE_URL_PREBID = "https://hrms.aimantra.info";
// let BASE_URL_PREBID = "https://5rn0m63d-8000.inc1.devtunnels.ms";

let TEST_URL_PREBID = "https://hrms.aimantra.info";
// TEST_URL_PREBID = "https://n00nmkv7-8000.inc1.devtunnels.ms";

// BASE_URL_PREBID = "https://n00nmkv7-8000.inc1.devtunnels.ms";

const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];
let IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

const AUTH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "application/json",
    accept: "application/json",
  },
};

const AUTHH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "multipart/form-data",
  },
};

export {
  BASE_URL,
  BASE_URL_PREBID,
  TEST_URL_PREBID,
  AUTH,
  AUTHH,
  FRONTEND_URL,
  IMAGE_URL,
};
